// Web Design Service Page Content - Extracted from nomu-marketing-website-guide.md
// Updated with modern React Icons

import { FaGlobe, FaCheckCircle, FaTachometerAlt, FaShieldAlt, FaSearch, FaWhatsapp, FaUsers, FaChartLine, FaLaptopCode, FaPalette, FaCode, FaFileAlt, FaVial, FaTools, FaComments, FaClipboardCheck } from 'react-icons/fa';
import { MdDevices, MdSpeed, MdSecurity, MdLanguage } from 'react-icons/md';
import { BiSupport } from 'react-icons/bi';
import { BsGlobe2, BsClock } from 'react-icons/bs';
import { AiOutlineShoppingCart } from 'react-icons/ai';
import { IoMdCheckmarkCircle } from 'react-icons/io';

// Import portfolio images
import Website1 from '../images/Website1.jpg';
import Website2 from '../images/Website2.jpg';
import Website3 from '../images/Website3.jpg';
import Website4 from '../images/Website4.jpg';
import Website5 from '../images/Website5.jpg';
import Website6 from '../images/Website6.jpg';
import Website7 from '../images/Website7.jpg';

export const webDesignContent = {
  hero: {
    title: "تصميم مواقع احترافية تعكس هويتك وتحقق أهدافك",
    subtitle: "نصنع لك موقع إلكتروني سريع، متجاوب، وسهل الاستخدام يساعدك على جذب العملاء وزيادة مبيعاتك",
    buttonText: "اطلب موقعك الآن",
    imageUrl: "https://via.placeholder.com/800x500/1A4D5C/2DD4BF?text=Web+Design"
  },

  whyNeed: {
    title: "لماذا موقعك الإلكتروني مهم؟",
    subtitle: "في عصر الإنترنت، موقعك هو واجهتك الرقمية الأولى",
    reasons: [
      {
        id: 1,
        icon: BsGlobe2,
        title: "حضور رقمي 24/7",
        description: "موقعك يعمل لك طوال اليوم حتى وأنت نائم"
      },
      {
        id: 2,
        icon: IoMdCheckmarkCircle,
        title: "بناء الثقة",
        description: "موقع احترافي يعطي انطباع قوي عن علامتك"
      },
      {
        id: 3,
        icon: FaChartLine,
        title: "زيادة المبيعات",
        description: "يساعدك على تحويل الزوار إلى عملاء"
      },
      {
        id: 4,
        icon: FaUsers,
        title: "الوصول لجمهور أوسع",
        description: "يمكن الناس من إيجادك بسهولة على الإنترنت"
      }
    ]
  },

  whatWeOffer: {
    title: "ماذا تحصل معنا؟",
    features: [
      {
        id: 1,
        icon: MdDevices,
        title: "تصميم عصري ومتجاوب",
        description: "موقع يعمل بسلاسة على الجوال والكمبيوتر"
      },
      {
        id: 2,
        icon: FaLaptopCode,
        title: "لوحة تحكم سهلة",
        description: "تستطيع تحديث المحتوى بنفسك بسهولة"
      },
      {
        id: 3,
        icon: FaTachometerAlt,
        title: "سرعة تحميل فائقة",
        description: "صفحات سريعة تحسّن تجربة المستخدم"
      },
      {
        id: 4,
        icon: FaSearch,
        title: "تحسين لمحركات البحث (SEO)",
        description: "نساعدك تظهر في نتائج جوجل"
      },
      {
        id: 5,
        icon: FaWhatsapp,
        title: "ربط بواتساب والسوشيال ميديا",
        description: "عملاؤك يتواصلون معك بضغطة زر"
      },
      {
        id: 6,
        icon: FaShieldAlt,
        title: "حماية وأمان",
        description: "شهادة SSL لحماية بيانات موقعك"
      },
      {
        id: 7,
        icon: BiSupport,
        title: "دعم فني بعد التسليم",
        description: "نبقى معك حتى بعد إطلاق الموقع"
      }
    ]
  },

  portfolio: {
    title: "نماذج من أعمالنا في تصميم المواقع",
    subtitle: "مواقع إلكترونية احترافية صممناها لعملائنا",
    projects: [
      {
        id: 1,
        title: "موقع تجاري احترافي",
        category: "تصميم مواقع الأعمال",
        description: "موقع شامل لشركة تجارية مع تصميم عصري وواجهة سهلة الاستخدام",
        image: Website1,
        features: ["تصميم متجاوب", "لوحة تحكم", "SEO محسّن"]
      },
      {
        id: 2,
        title: "منصة إلكترونية متكاملة",
        category: "تطوير مواقع ويب",
        description: "منصة رقمية متكاملة مع نظام إدارة محتوى متقدم",
        image: Website2,
        features: ["نظام CMS", "متعدد اللغات", "سرعة عالية"]
      },
      {
        id: 3,
        title: "متجر إلكتروني عصري",
        category: "التجارة الإلكترونية",
        description: "متجر إلكتروني احترافي مع بوابات دفع متعددة",
        image: Website3,
        features: ["بوابات دفع", "إدارة منتجات", "ربط الشحن"]
      },
      {
        id: 4,
        title: "موقع شركة حديث",
        category: "مواقع الشركات",
        description: "موقع مؤسسي احترافي يعكس هوية الشركة بشكل متميز",
        image: Website4,
        features: ["تصميم فريد", "صفحات متعددة", "تجربة مميزة"]
      },
      {
        id: 5,
        title: "موقع عيادات طبية",
        category: "القطاع الصحي",
        description: "موقع طبي احترافي مع نظام حجز المواعيد",
        image: Website5,
        features: ["حجز المواعيد", "عرض الخدمات", "معلومات الأطباء"]
      },
      {
        id: 6,
        title: "موقع الحدائق والمزارع",
        category: "الخدمات الزراعية",
        description: "موقع متخصص للحدائق مع معرض أعمال تفاعلي",
        image: Website6,
        features: ["معرض صور", "طلب الخدمات", "تصميم أخضر"]
      }
    ]
  },

  packagesSection: {
    title: "اختر الباقة المناسبة لك",
    subtitle: "باقات مرنة تناسب كل الميزانيات والاحتياجات"
  },

  packages: [
    {
      id: 'start',
      title: 'باقة البداية',
      subtitle: 'الأفراد وأصحاب المشاريع الصغيرة',
      isFeatured: false,
      features: [
        'صفحة واحدة احترافية (Landing Page)',
        'تصميم متجاوب (Responsive)',
        'ربط واتساب للتواصل السريع',
        'سرعة تحميل محسّنة',
        'نموذج تواصل بسيط',
        'التسليم خلال 4 أيام'
      ],
      whatsappMessage: `مرحباً

أنا مهتم بـــ باقة البداية لتصميم المواقع

تفاصيل الباقة:
- صفحة واحدة (Landing Page)
- تصميم متجاوب
- ربط واتساب
- سرعة محسّنة
- تسليم خلال 4 أيام

أرغب في معرفة السعر وتفاصيل أكثر.`
    },
    {
      id: 'grow',
      title: 'باقة النمو',
      subtitle: 'الشركات الصغيرة والمتوسطة',
      badge: 'الأكثر طلباً',
      isFeatured: true,
      features: [
        'موقع من 3-5 صفحات',
        'تصميم احترافي مخصص',
        'استضافة مجانية سنة كاملة',
        'تحسين أساسي لمحركات البحث (SEO)',
        'ربط البريد الإلكتروني',
        'نموذج تواصل متقدم',
        'ربط Google Analytics',
        'تحسين تجربة المستخدم (UX)',
        'لوحة تحكم لإدارة المحتوى',
        'دعم فني 30 يوم'
      ],
      whatsappMessage: `مرحباً

أنا مهتم بـــ باقة النمو لتصميم المواقع

تفاصيل الباقة:
- موقع 3-5 صفحات
- تصميم احترافي مخصص
- استضافة مجانية سنة
- SEO أساسي
- ربط بريد إلكتروني
- Google Analytics
- دعم فني 30 يوم

أرغب في معرفة السعر والبدء.`
    },
    {
      id: 'premium',
      title: 'باقة الاحتراف',
      subtitle: 'الشركات الكبيرة والعلامات التجارية',
      isFeatured: false,
      features: [
        'موقع كامل متعدد الصفحات',
        'تصميم UI/UX مخصص واحترافي',
        'سرعة تحميل فائقة',
        'تحسين متقدم لمحركات البحث (SEO)',
        'استضافة + حماية SSL سنة كاملة',
        'بريد إلكتروني احترافي للشركة',
        'ربط أدوات التسويق والتحليل',
        'تحسين معدل التحويل (CRO)',
        'نظام إدارة محتوى متقدم',
        'دعم فني لمدة 6 شهور',
        'تدريب على استخدام الموقع'
      ],
      whatsappMessage: `مرحباً

أنا مهتم بـــ باقة الاحتراف لتصميم المواقع

تفاصيل الباقة:
- موقع كامل متعدد الصفحات
- تصميم UI/UX مخصص
- سرعة تحميل فائقة
- SEO متقدم
- استضافة + SSL سنة
- بريد احترافي
- دعم فني 6 شهور

أرغب في معرفة السعر وحجز استشارة.`
    },
    {
      id: 'ecommerce',
      title: 'باقة المتجر الإلكتروني',
      subtitle: 'أصحاب المتاجر والبائعين أونلاين',
      description: 'انطلق بمتجرك الرقمي',
      isFeatured: false,
      features: [
        'تصميم متجر احترافي متوافق مع كل الأجهزة',
        'حتى 50 منتج (قابل للزيادة)',
        'بوابات دفع: مدى، Apple Pay، STC Pay، وغيرها',
        'ربط مع شركات الشحن: سمسا، أرامكس، وغيرها',
        'لوحة تحكم لإدارة المنتجات والمبيعات',
        'دعم اللغتين: العربية والإنجليزية',
        'قسم العروض والكوبونات',
        'صفحات سياسة الخصوصية والاسترجاع جاهزة',
        'تحسين أساسي لمحركات البحث (SEO)',
        'ربط المتجر بحسابات السوشيال ميديا',
        'تدريب فيديو على استخدام المتجر',
        'دعم فني 60 يوم'
      ],
      whatsappMessage: `مرحباً

أنا مهتم بـــ باقة المتجر الإلكتروني

تفاصيل الباقة:
- متجر احترافي متجاوب
- حتى 50 منتج
- بوابات دفع (مدى، Apple Pay، STC Pay)
- ربط شركات شحن
- لوحة تحكم سهلة
- دعم العربية والإنجليزية
- دعم فني 60 يوم

أرغب في معرفة السعر والتفاصيل.`
    }
  ],

  technologies: {
    title: "التقنيات والأدوات التي نستخدمها",
    subtitle: "نعتمد على أحدث التقنيات والأدوات لضمان موقع احترافي وعالي الأداء",
    tools: [
      {
        id: 1,
        icon: FaCode,
        title: "تقنيات حديثة",
        description: "React, Vue.js, WordPress - نختار التقنية المناسبة لمشروعك"
      },
      {
        id: 2,
        icon: FaTachometerAlt,
        title: "تحسين الأداء",
        description: "نستخدم تقنيات متقدمة لضمان سرعة تحميل فائقة"
      },
      {
        id: 3,
        icon: FaShieldAlt,
        title: "أمان متقدم",
        description: "SSL، Firewall، وحماية من الاختراقات"
      },
      {
        id: 4,
        icon: FaSearch,
        title: "SEO محترف",
        description: "تحسين محركات البحث لظهور أفضل في جوجل"
      }
    ]
  },

  benefits: {
    title: "الفوائد التي تحصل عليها",
    subtitle: "موقعك الإلكتروني الاحترافي يحقق لك نتائج ملموسة",
    items: [
      {
        id: 1,
        icon: IoMdCheckmarkCircle,
        title: "زيادة المصداقية",
        description: "موقع احترافي يزيد ثقة العملاء في علامتك التجارية بنسبة تصل إلى 75%"
      },
      {
        id: 2,
        icon: FaChartLine,
        title: "نمو المبيعات",
        description: "الشركات التي لديها مواقع احترافية تحقق مبيعات أعلى بـ 3 أضعاف"
      },
      {
        id: 3,
        icon: FaUsers,
        title: "وصول أوسع",
        description: "تصل لعملائك على مدار 24/7 في أي مكان بالعالم"
      },
      {
        id: 4,
        icon: FaLaptopCode,
        title: "تحكم كامل",
        description: "إدارة سهلة لمحتوى موقعك دون الحاجة لخبرة تقنية"
      }
    ]
  },

  guarantee: {
    title: "ضماناتنا الحصرية لك",
    items: [
      {
        id: 1,
        icon: IoMdCheckmarkCircle,
        title: "ضمان سرعة التحميل",
        description: "نضمن سرعة تحميل أقل من 3 ثوانٍ أو نحسنه مجاناً"
      },
      {
        id: 2,
        icon: MdDevices,
        title: "توافق 100%",
        description: "موقعك يعمل بكفاءة على جميع الأجهزة والمتصفحات"
      },
      {
        id: 3,
        icon: BiSupport,
        title: "دعم مستمر",
        description: "دعم فني مجاني حسب الباقة + صيانة دورية"
      },
      {
        id: 4,
        icon: FaShieldAlt,
        title: "أمان مضمون",
        description: "حماية كاملة ضد الاختراقات وشهادة SSL مجانية"
      }
    ]
  },

  process: {
    title: "كيف نصمم موقعك؟",
    steps: [
      {
        id: 1,
        number: "1",
        icon: FaComments,
        title: "الاستشارة والتخطيط",
        description: "نفهم احتياجاتك وأهدافك ونضع الخطة"
      },
      {
        id: 2,
        number: "2",
        icon: FaPalette,
        title: "التصميم الأولي",
        description: "نصمم واجهة الموقع ونرسلها لك للمراجعة"
      },
      {
        id: 3,
        number: "3",
        icon: FaCode,
        title: "التطوير والبرمجة",
        description: "نبني الموقع بأحدث التقنيات"
      },
      {
        id: 4,
        number: "4",
        icon: FaClipboardCheck,
        title: "المراجعة والتعديلات",
        description: "تراجع العمل ونعدّل حسب ملاحظاتك"
      },
      {
        id: 5,
        number: "5",
        icon: FaVial,
        title: "الاختبار والإطلاق",
        description: "نختبر كل شيء ونطلق موقعك للعالم"
      },
      {
        id: 6,
        number: "6",
        icon: FaTools,
        title: "الدعم المستمر",
        description: "نبقى معك للمتابعة والدعم الفني"
      }
    ]
  },

  faq: {
    title: "أسئلة شائعة عن تصميم المواقع",
    items: [
      {
        id: 1,
        question: "كم المدة المتوقعة لتصميم الموقع؟",
        answer: `يعتمد على الباقة:
- باقة البداية: 4 أيام
- باقة النمو: 7-10 أيام
- باقة الاحتراف: 14-21 يوم
- المتجر الإلكتروني: 21-30 يوم`
      },
      {
        id: 2,
        question: "هل أستطيع تعديل محتوى الموقع بنفسي؟",
        answer: "نعم، نوفر لك لوحة تحكم سهلة + تدريب بسيط على استخدامها"
      },
      {
        id: 3,
        question: "هل تقدمون استضافة الموقع؟",
        answer: "نعم، الباقات المتقدمة تشمل استضافة سنة مجاناً مع شهادة SSL للحماية"
      },
      {
        id: 4,
        question: "هل الموقع متوافق مع الجوال؟",
        answer: "بالتأكيد، جميع مواقعنا متجاوبة 100% وتعمل بسلاسة على جميع الأجهزة"
      },
      {
        id: 5,
        question: "ماذا بعد إطلاق الموقع؟",
        answer: "نقدم دعم فني مجاني حسب الباقة + خدمة صيانة وتحديث اختيارية"
      }
    ]
  },

  finalCTA: {
    title: "جاهز لموقع يحقق أهدافك؟",
    subtitle: "تواصل معنا الآن واحصل على استشارة مجانية",
    buttonText: "ابدأ مشروعك الآن"
  }
};
